import { render, staticRenderFns } from "./LayoutContentStudent.vue?vue&type=template&id=0500d5f0&"
import script from "./LayoutContentStudent.vue?vue&type=script&lang=js&"
export * from "./LayoutContentStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports